module.exports = __webpack_public_path__ + "static/media/uoa-28.d51cf01f.jpg";